import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { useAuth } from '../contexts/AuthContext';

interface UserPreferences {
  city: string;
  zip_code: string;
  distance_miles: number;
  age_ranges: string[];
  email_digest_enabled: boolean;
  email_digest_day: string;
}

export const useUserPreferences = () => {
  const { user } = useAuth();
  const [preferences, setPreferences] = useState<UserPreferences | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPreferences = async () => {
      if (!user) {
        setLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from('user_preferences')
          .select('*')
          .eq('user_id', user.id)
          .maybeSingle();

        if (error) {
          console.error('useUserPreferences: Error loading preferences:', error);
          throw error;
        }

        if (data) {
          setPreferences(data);
        } else {
          setPreferences(null);
        }
      } catch (error) {
        console.error('useUserPreferences: Exception:', error);
      } finally {
        setLoading(false);
      }
    };

    loadPreferences();
  }, [user]);

  return { preferences, loading };
};
